export default "__VITE_ASSET__BRvDCq01__"